import React from "react";
import AuthProvider from "./src/components/domain/shared/auth/AuthProvider";
import AuthWrapper from "./src/components/domain/shared/auth/AuthWrapper";
// Self-hosted Poppins (weights used by global.scss / material-ui theme). Avoids a
// request to fonts.googleapis.com/fonts.gstatic.com, which would send every
// visitor's IP address to Google outside of any cookie/consent mechanism.
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/700.css";
import "./src/styles/global.scss";

export const wrapRootElement = ({ element }) => (
  <AuthProvider>
    <AuthWrapper>
      {element}
    </AuthWrapper>
  </AuthProvider>
);
